<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Редактировать район
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'district-details', params: { district_id: district.id }}">← Назад к Деталям района</router-link>
    </div>

    <div class="text-right">
      <a v-if="district.id" class="red" href="#" @click.prevent="deleteDistrict">удалить район</a>
    </div>

    <district-edit-form
      :district="district"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getDistrict, deleteDistrict } from '@/services/district.service'
import districtEditForm from '@/components/forms/district/DistrictEditForm'

export default {
  name: 'district-edit',
  components: { districtEditForm },
  data () {
    return {
      district: {
        id: null,
        name: '',
        city: ''
      },

      errors: {
        district: {
          id: [],
          name: [],
          city: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.district_id !== undefined) {
      this.district.id = this.$route.params.district_id

      getDistrict(this.district.id).then((response) => {
        this.district = response.data
      })
    }
  },
  methods: {
    deleteDistrict () {
      deleteDistrict(this.district.id).then((response) => {
        this.showMsg('Район был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'city-details', params: { city_id: this.$route.params.city_id } })
        return true
      }).catch(err => {
        console.log(err)
        this.showMsg('Район был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'city-details', params: { city_id: this.$route.params.city_id } })
        return true
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// DistrictEdit.vue?0da88652